export const environment = {
  production: true,
  ambiente: 'production',
  server: 'https://videoconsulta.urg.com.ar/api'
}